import {useEffect, useState} from "react";
import VerticalCard from "./verticalCard";
import NavigationBar from "./navigationBar";
import DescriptionWithLogos from "./descriptionWithLogos";
import FreeMonthForm from "./forms/freeMonthForm";
import MainForm from "./forms/mainForm";
import EasyCheckout from "./home/easyCheckout";
import ThreeCardSelection from "./home/threeCardSelection";
import FullPagePopupBanner from "./banners/fullPagePopupBanner";
import {currentHolidayLong, currentHolidayShort, isHolidayFocus} from "../models/variableCopywriting";


export default function HeroSection(props) {

    // TODO: Export the navigation
    return (
        <div className="">

            <body className="home page-template-default page page-id-292">

            <FullPagePopupBanner />

            <NavigationBar/>

            <main>
                <section className="container container-wide container-single">
                    <section className="home-hero alignfull"
                             style={{
                                 "background": "url(https://images.pexels.com/photos/7223025/pexels-photo-7223025.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2) center center no-repeat #0B1836"
                             }}
                    >
                        <div className="container">
                            <figure className="">
                                <img decoding="async"
                                     src="https://images.pexels.com/photos/7223025/pexels-photo-7223025.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                                     alt="Image of woman leader"/>
                            </figure>
                            <div className="form">

                                <div>
                                    <div>
                                        <div>
                                            <h3>
                                                <div className="custom-font mb-12 justify-center items-center">
                                                    {
                                                        isHolidayFocus ?
                                                            <span>{currentHolidayShort} SEO </span> :
                                                            <span>HERSTORY SEO</span>
                                                    }
                                                </div>
                                                <strong>LET’S <span className="text-red-600">WIN</span> THIS.</strong><br/></h3>
                                        </div>
                                        <div>
                                            <div className="custom-font font-thin text-white">
                                                If you’ve been waiting for the right time to improve your online
                                                visibility,
                                                that time is NOW. Get the expert assistance you need from Shopify SEO
                                                specialists.
                                            </div>


                                            <MainForm/>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                </section>


            </main>
            </body>


        </div>
    )
}